/**
 * Styled Components - Created by david on 07/02/18.
 */
import styled, { keyframes } from 'styled-components'
import { BLUE, GRAY_DARK, RED } from '../../theme/colors'
import Menu from 'antd/lib/menu'
import Divider from 'antd/lib/divider'
import Icon from 'antd/lib/icon'

const showMenu = keyframes`
  from { opacity: 0};
  to {opacity: 1, visibility: visible};
`

export const Container = styled.div`
  display: flex;
  width: 72%;
  justify-content: space-between;
  flex-direction: row;
  transition: all .25s;
`

interface OptionDropdownProps {
  selected?: boolean
  bold?: boolean
  index?: number
  secondary?: boolean
}

export const OptionDropdown = styled.h1`
  color: ${({ selected }: OptionDropdownProps) => (selected ? RED : GRAY_DARK)};
  font-size: 15.5px;
  cursor: pointer;
  padding-top: 5px;
  font-family: Avenir;
  font-weight: ${({ bold }: OptionDropdownProps) => bold ? 'bold' : 'normal'};
  @media (max-width: 1240px) {
    font-size: 14px;
  }
  animation: fade-in-left 0.25s cubic-bezier(0.390, 0.575, 0.565, 1.000) 
  ${({ index }: OptionDropdownProps) => index ? `${index * 0.07}s` : '0s'} both;
  @keyframes fade-in-left {
    0% {
      transform: translateX(-7px);
      opacity: 0;
    }
    100% {
      transform: translateX(0);
      opacity: 1;
    }
  }
`

export const Text = styled.div`
  color: #5f6062;
  font-size: 14px;
  cursor: pointer;
`

export const OptionItem = styled.div`
  font-weight: bold;
  font-family: Avenir;
  height: 30px;
  width: max-content;
  &:hover {
    cursor: pointer;
  }
`

export const ResultsContainer = styled.div`
  display: flex;
`

export const SportsList = styled.div`
  transition: all .15s;
  margin-left: ${({ secondary }: OptionDropdownProps) => secondary ? '0px' : '14vw'};
`

export const TilesContent = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  margin-top: 12px;
  margin-bottom: 8px;
`

export const Tile = styled.div`
  margin-right: 18px;
  position: relative;
  &:last-child {
    margin-right: 0px;
  }
  &:hover {
    cursor: pointer;
    img {
      transform: scale(1.1);
      transform-origin: 50% 50%;
    }
    .subtitleTile {
      background: ${BLUE};
    }
  }
`

export const ContainerImage = styled.div`
  max-width: 170px;
  overflow: hidden;
  border-radius: 7px;
  box-shadow: 1px 2px 4px 0px gray;
`

export const TileImage = styled.img`
  width: 100%;
  transition: transform .25s;
`

export const TileSubtitle = styled.div`
  position: absolute;
  bottom: 0px;
  padding-left: 12px;
  background: #0000006e;
  width: 100%;
  color: white;
  left: 0;
  padding-bottom: 4px;
  padding-top: 4px;
  border-bottom-left-radius: 7px;
  border-bottom-right-radius: 7px;
  font-family: Avenir;
  font-weight: bold;
  font-size: 16px;
  transition: background .25s;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const Line = styled.div`
  height: 2px;
  background-color: #e61737;
`

export const ArrowIcon = styled(Icon)`
  background: #f0f0f0;
  border-radius: 25px;
  padding: 2px;
  font-size: 8px;
  margin-left: 6px;
  color: cornflowerblue;
`

export const ArrowDown = styled.img`
  margin-left: 16px;
  margin-right: -20px;
  margin-top: -1px;
  opacity: 0.7;
`

export const VisitPage = styled.div`
  color: cornflowerblue;
  font-size: 10px;
  margin-left: 8px;
  padding: 1px 4px;
  border: 1px solid cornflowerblue;
  border-radius: 3px;
  background: white;
  font-weight: normal;
  font-family: Avenir-Medium;
  margin-top: -1px;
  margin-right: -2px;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    background: cornflowerblue;
    color: white;
  }
`

export const Option = styled.div`
  height: 100%;
`

export const overStyle = {
  paddingTop: 4,
  width: '100%'
}

export const dropStyle = {
  paddingTop: 4,
  width: '100%',
  maxWidth: '336px'
}

export const menuStyle = {
  backgroundColor: 'transparent',
  borderBottom: 0,
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%'
} as React.CSSProperties

export const StyledMenu = styled(Menu)`
  background-color: transparent;
  border-bottom: 0;
  display: flex;
  justify-content: space-between;
  width: 100%;
  transition: all 1s ease-in;
  animation: ${showMenu} 1s ease-in;
`

export const StyledDivider = styled(Divider)`
  height: 45px;
  background: #b7b7b7;
`

export const ContentOptions = styled.div`
  margin-left: -14px;
  margin-right: -14px;
  .title {
    font-size: 13px;
    text-align: center;
    font-weight: bold;
    font-family: Avenir;
    color: #4e4e4e;
  }
`

export const ContentItem = styled.div`
  font-size: 16px;
  padding: 6px 18px;
  padding-right: 14px;
  font-family: Avenir;
  display: flex;
  align-items: center;
  transition: all .25s;
  &:hover {
    background: whitesmoke;
    border-radius: 5px;
    color: cornflowerblue;
    cursor: pointer;
  }
`

export const ContentIcon = styled.img`
  margin-right: 10px;
  max-width: 38px;
  align-self: flex-start;
  margin-top: 8px;
  margin-left: -2px;
`

export const ContentName = styled.div`
  max-width: 100%;
  width: 100%;
  font-size: 14px;
  font-family: Avenir;
  .subtitle {
    display: inline-block;
    font-size: 12px;
    font-weight: 500;
    margin-left: 8px;
    margin-top: -2px;
    vertical-align: middle;
  }
`

export const DescriptionContent = styled.div`
  font-size: 12px;
  color: #626262;
  font-family: Avenir;
  font-weight: normal;
  line-height: 1.45;
`

export const RightArrow = styled(Icon)`
  font-size: 12px;
  color: #4e7cd0;
  margin-left: 8px;
  border: 1px solid #a7c6ff;
  border-radius: 25px;
  padding: 3px;
`

export const RightArrowTile = styled(Icon)`
  font-size: 8px;
  color: #edf3ff;
  border: 1px solid #808ca4;
  border-radius: 25px;
  padding: 3px;
  margin-right: 12px;
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/DropdownList/styledComponents.tsx